<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择物料"
      width="1200px"
      top="8vh"
  >
    <view-table
        ref="tableSelect"
        :filter="filter"
        :columns-property="columnsProperty"
        module="basic"
        url="sapBaseMaterials"
        @select="selectHandle"
        @reset="resetHandle"
    >
      <template slot="otherBtn">
        <div style="margin: 5px 0;">
          <el-button type="primary" @click="handleSelectMaterial">选择</el-button>
        </div>
      </template>
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="物料编号" prop="no">
            <el-input v-model="filter.no" placeholder="请输入物料编号" clearable/>
          </el-form-item>
          <el-form-item label="旧物料编号" prop="no">
            <el-input v-model="filter.mappingMaterialNo" placeholder="请输入旧物料编号" clearable/>
          </el-form-item>
          <el-form-item label="物料名称" prop="name">
            <el-input v-model="filter.name" placeholder="请输入物料名称" clearable/>
          </el-form-item>
          <el-form-item label="规格型号" prop="specification">
            <el-input v-model="filter.specification" placeholder="请输入规格型号" clearable/>
          </el-form-item>
          <el-form-item label="厂家型号" prop="manufacturerModel">
            <el-input v-model="filter.manufacturerModel" placeholder="请输入厂家型号" clearable/>
          </el-form-item>
          <el-form-item label="营销定级" prop="marketingLevel">
            <el-select v-model="filter.marketingLevel" clearable placeholder="请选择营销定级">
              <el-option label="S级战略主推" value="S级战略主推"/>
              <el-option label="A级常规主推" value="A级常规主推"/>
              <el-option label="B级限销维持" value="B级限销维持"/>
              <el-option label="C级禁售退市" value="C级禁售退市"/>
            </el-select>
          </el-form-item>
          <el-form-item label="退市管理" prop="delistStatus">
            <el-select v-model="filter.delistStatus" clearable placeholder="请选择退市管理">
              <el-option label="在售" value="10"/>
              <el-option label="待退市" value="20"/>
              <el-option label="消耗库存" value="30"/>
              <el-option label="停售" value="40"/>
            </el-select>
          </el-form-item>
        </el-form>
      </template>
    </view-table>
  </el-dialog>
</template>

<script>
  import ViewTable from "@/components/ViewTable";

  export default {
    components: {ViewTable},
    props: {
      isMultiSelect: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        dialogVisible: false,
        filter: {
          no: "",
          name: "",
          mrpType: "",
          status: "",
          priceStatus: "",
          specification: "",
          mappingMaterialNo: "",
          manufacturerModel: "",
          marketingLevel: "",
          delistStatus: "",
          noDelistStatus: "",
        },
        selectedRows: [],
      };
    },
    computed: {
      columnsProperty() {
        const baseColumns = [
          {
            title: "物料编号",
            key: "no",
            width: 120,
          },
          {
            title: "旧料号",
            key: "mappingMaterialNo",
            width: 120,
          },
          {
            title: "物料名称",
            key: "name",
            width: 200,
            tooltip: true,
          },
          {
            title: "规格型号",
            key: "zmyxh",
          },
          {
            title: "厂家型号",
            key: "manufacturerModel",
          },
          {
            title: "品名",
            key: "sapProductName",
          },
          {
            title: "营销定级",
            key: "marketingLevel",
            width: 120,
          },
          {
            title: "退市管理",
            key: "delistStatusName",
            width: 100,
          },
          {
            title: "标准交期",
            key: "standardDeliveryTime",
            width: 100,
          },
        ];

        return baseColumns;
      },
    },
    methods: {
      open(filter) {
        this.dialogVisible = true;
        if (filter) {
          this.filter.status = filter.status;
          this.filter.priceStatus = filter.priceStatus;
          this.filter.noDelistStatus = filter.noDelistStatus;
        }
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.$refs.tableSelect.loadData();
        });
      },
      selectHandle(selection) {
        this.selectedRows = selection;
      },
      // 选择按钮：单选返回单个物料，多选返回物料数组
      handleSelectMaterial() {
        if (!this.selectedRows.length) {
          this.$message.warning("请选择物料");
          return;
        }
        this.dialogVisible = false;
        if (this.isMultiSelect) {
          this.$emit("select-change", this.selectedRows);
        } else {
          this.$emit("select", this.selectedRows[0]);
        }
      },

      // 重置特殊处理
      resetHandle() {
        this.filter.no = "";
        this.filter.name = "";
        this.$refs.tableSelect.loadData();
      },
    },
  };
</script>
